import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    container: {
        paddingTop: 0
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitleContainer: {
        position: "absolute",
        right: 0,
        left: 0,
        alignItems: "center"
    },
    headerTitle: {
        textAlign: "center"
    },
    loadingContainer: {
        alignItems: "center",
        justifyContent: "center"
    },
    scrollView: {
        flex: 1
    }
});
export default stylesheet;
